import axios from 'axios';
//let token = localStorage['user-token'];
//console.log('token= '+token)
export const api = axios.create({
  baseURL: process.env.REACT_APP_CI_URL
  //baseURL: 'http://localhost:8080/'
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage['user-token']; // Example: get token from local storage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default axios;